import { ApiMethod } from '@wajeez-web/stores/base';
import { AlertType, CommonActions } from '@wajeez-web/stores/common';
import { paymentClient, Server } from '@wajeez-web/core/api-base';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { AlertInput } from './types';

export const name = 'vouchers';

export const checkVoucherValidity: ApiMethod<
  Server.CheckVoucherValidityInput & AlertInput,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    dispatch(CommonActions.showLoading({ show: true }));

    const client = new Server.Server_Vouchers_Client(undefined, paymentClient);

    const response = await client.vouchers_checkValidity_post_V1(data);

    return rejectWithValue(response.errors);
  } catch (error: any) {
    dispatch(CommonActions.hideLoading());

    const errors = { ...error.response }.data;

    dispatch(
      CommonActions.setAlert({
        for: data.alert?.for,
        show: true,
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(errors);
  }
};

export const checkVoucherValidityAsync = createAsyncThunk(
  name + '/checkVoucherValidity',
  checkVoucherValidity
);
